/* Lane Studios — theme interactions */
(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ---------- LOADER ---------- */
  var loader = document.getElementById("loader");
  var bootBar = document.getElementById("bootBar");
  var bootRead = document.getElementById("bootRead");
  var reads = ["INITIALIZING","SONY A7 IV CONNECTED","SIGMA 24-70 F2.8 DG DN II","ISO 100 \u00B7 1/250 \u00B7 f/2.8","SYSTEM READY"];
  var hero = document.querySelector(".hero");
  function endLoader(){ if(loader){ loader.classList.add("done"); } if(hero){ hero.classList.add("lit"); } }
  if(reduce){ if(bootBar) bootBar.style.width="100%"; setTimeout(endLoader,300); }
  else if(loader){
    var ri=0;
    var rInt=setInterval(function(){ ri++; if(bootRead&&reads[ri]) bootRead.textContent=reads[ri]; if(ri>=reads.length-1) clearInterval(rInt); },300);
    setTimeout(function(){ if(bootBar){ bootBar.style.transition="width 1.3s cubic-bezier(.22,.61,.18,1)"; bootBar.style.width="100%"; } },80);
    setTimeout(endLoader,1750);
  } else if(hero){ hero.classList.add("lit"); }
  ["click","keydown","wheel","touchstart"].forEach(function(ev){
    window.addEventListener(ev,function(){ if(loader&&!loader.classList.contains("done")) endLoader(); },{passive:true});
  });
  window.addEventListener("load",function(){ setTimeout(function(){ if(loader&&!loader.classList.contains("done")) endLoader(); },1800); });

  /* ---------- CUSTOM CURSOR ---------- */
  if(fine && !reduce){
    document.body.classList.add("has-cursor");
    var ring=document.getElementById("cursorRing"), dot=document.getElementById("cursorDot");
    if(ring&&dot){
      var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
      window.addEventListener("mousemove",function(e){ mx=e.clientX; my=e.clientY; dot.style.transform="translate("+mx+"px,"+my+"px) translate(-50%,-50%)"; },{passive:true});
      (function loop(){ rx+=(mx-rx)*.18; ry+=(my-ry)*.18; ring.style.transform="translate("+rx+"px,"+ry+"px) translate(-50%,-50%)"; requestAnimationFrame(loop); })();
      document.querySelectorAll("a,button,input,select,textarea,.path,.tab,.ba").forEach(function(el){
        el.addEventListener("mouseenter",function(){ document.body.classList.add("cursor-hover"); });
        el.addEventListener("mouseleave",function(){ document.body.classList.remove("cursor-hover"); });
      });
    }
  } else { var cr=document.getElementById("cursorRing"),cd=document.getElementById("cursorDot"); if(cr)cr.style.display="none"; if(cd)cd.style.display="none"; }

  /* ---------- SCROLL: progress, nav, parallax, side hud ---------- */
  var nav=document.getElementById("nav"), progress=document.getElementById("progress");
  var orbs=document.querySelectorAll("[data-par]");
  var hudLinks=document.querySelectorAll(".side-hud a");
  var ticking=false;
  function onScroll(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){
    var y=window.scrollY, h=document.documentElement.scrollHeight-innerHeight;
    if(nav) nav.classList.toggle("scrolled",y>30);
    if(progress) progress.style.width=(h>0?(y/h*100):0)+"%";
    if(!reduce && innerWidth>680){ orbs.forEach(function(o){ var s=parseFloat(o.getAttribute("data-par")); o.style.transform="translate3d(0,"+(y*s)+"px,0)"; }); }
    ticking=false;
  }); }
  window.addEventListener("scroll",onScroll,{passive:true}); onScroll();

  if(hudLinks.length){
    var secSpy=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ var id=e.target.id; hudLinks.forEach(function(a){ a.classList.toggle("active",a.getAttribute("data-sec")===id); }); } });
    },{threshold:.5});
    document.querySelectorAll("[data-spy]").forEach(function(el){ secSpy.observe(el); });
  }

  /* ---------- REVEAL ---------- */
  var io=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } }); },{threshold:.12,rootMargin:"0px 0px -8% 0px"});
  document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });

  /* ---------- SCRAMBLE HEADINGS ---------- */
  if(!reduce){
    var chars="ABCDEFGHIJKLMNOPQRSTUVWXYZ#%*<>/[]{}";
    var sio=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ scramble(e.target); sio.unobserve(e.target); } }); },{threshold:.5});
    document.querySelectorAll(".scramble").forEach(function(el){ sio.observe(el); });
    function scramble(el){
      var txt=el.textContent, i=0;
      var iv=setInterval(function(){
        el.textContent=txt.split("").map(function(c,idx){ if(c===" ") return " "; if(idx<i) return txt[idx]; return chars[Math.floor(Math.random()*chars.length)]; }).join("");
        i+=1; if(i>txt.length){ clearInterval(iv); el.textContent=txt; }
      },28);
    }
  }

  /* ---------- COUNTERS ---------- */
  var cio=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); cio.unobserve(e.target); } }); },{threshold:.6});
  document.querySelectorAll("[data-count]").forEach(function(el){ cio.observe(el); });
  function countUp(el){
    var target=parseFloat(el.getAttribute("data-count")), suffix=el.getAttribute("data-suffix")||"";
    var span=el.querySelector("span"), spanHTML=span?span.outerHTML:"";
    if(reduce){ el.innerHTML=target+suffix+spanHTML; return; }
    var start=null,dur=1300;
    function step(ts){ if(!start)start=ts; var p=Math.min((ts-start)/dur,1); var val=Math.floor((1-Math.pow(1-p,3))*target); el.innerHTML=val+(p>=1?suffix:"")+spanHTML; if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }

  /* ---------- MAGNETIC BUTTONS ---------- */
  if(fine && !reduce){
    document.querySelectorAll(".mag").forEach(function(b){
      b.addEventListener("mousemove",function(e){ var r=b.getBoundingClientRect(); var x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2; b.style.transform="translate("+x*.25+"px,"+y*.35+"px)"; });
      b.addEventListener("mouseleave",function(){ b.style.transform=""; });
    });
  }

  /* ---------- HERO CAMERA TILT + TIMECODE ---------- */
  var stage=document.getElementById("camStage"), tilt=document.getElementById("camTilt");
  if(stage && tilt && fine && !reduce){
    stage.addEventListener("mousemove",function(e){ var r=stage.getBoundingClientRect(); var px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5; tilt.style.transform="rotateY("+px*10+"deg) rotateX("+(-py*10)+"deg)"; });
    stage.addEventListener("mouseleave",function(){ tilt.style.transform="rotateY(0) rotateX(0)"; });
  }
  var tcode=document.getElementById("tcode"), t=0;
  if(tcode && !reduce){ setInterval(function(){ t++; var m=String(Math.floor(t/60)).padStart(2,"0"), s=String(t%60).padStart(2,"0"); tcode.textContent="00:"+m+":"+s; },1000); }

  /* ---------- CAMERA MEDIA (swap to video if provided) ---------- */
  var gm=document.getElementById("gearMedia");
  if(gm && gm.getAttribute("data-video")){
    var vid=gm.getAttribute("data-video").trim();
    if(vid){
      var existing=document.getElementById("gearCam");
      var v=document.createElement("video"); v.id="gearCam"; v.src=vid;
      v.autoplay=true; v.muted=true; v.loop=true; v.playsInline=true; v.setAttribute("playsinline","");
      if(existing) existing.replaceWith(v); else gm.prepend(v);
    }
  }
  var heroCam=document.getElementById("heroCam"), heroFallback=document.getElementById("heroCamFallback");
  if(heroCam && heroFallback){ heroCam.addEventListener("error",function(){ heroCam.style.display="none"; heroFallback.style.display="grid"; }); }

  /* ---------- MOBILE MENU ---------- */
  var mt=document.getElementById("menuToggle"), mm=document.getElementById("mobileMenu");
  if(mt && mm){
    mt.addEventListener("click",function(){ var open=mm.classList.toggle("open"); document.body.classList.toggle("menu-open",open); mt.setAttribute("aria-label",open?"Close menu":"Open menu"); });
    mm.querySelectorAll("a").forEach(function(a){ a.addEventListener("click",function(){ mm.classList.remove("open"); document.body.classList.remove("menu-open"); }); });
  }

  /* ---------- PACKAGE TABS ---------- */
  var tabs=document.querySelectorAll(".tab"), groups=document.querySelectorAll(".pkg-group");
  tabs.forEach(function(tb){ tb.addEventListener("click",function(){ tabs.forEach(function(x){x.classList.remove("active");}); tb.classList.add("active"); var cat=tb.getAttribute("data-cat"); groups.forEach(function(g){ g.classList.toggle("active",g.getAttribute("data-group")===cat); }); }); });

  /* ---------- BOOKING PATH -> SELECT ---------- */
  var paths=document.querySelectorAll(".path"), needSelect=document.getElementById("needSelect");
  var mapSel={brand:"Brand building",photo:"Photoshoot",both:"Both"};
  paths.forEach(function(p){ p.addEventListener("click",function(){ paths.forEach(function(x){x.classList.remove("sel");}); p.classList.add("sel"); var v=mapSel[p.getAttribute("data-path")]; if(needSelect){ for(var i=0;i<needSelect.options.length;i++){ if(needSelect.options[i].text===v) needSelect.selectedIndex=i; } } }); });

  /* ---------- BEFORE / AFTER ---------- */
  var range=document.getElementById("baRange"), graded=document.getElementById("baGraded"), handle=document.getElementById("baHandle"), knob=document.getElementById("baKnob");
  function setBA(v){ graded.style.clipPath="inset(0 "+(100-v)+"% 0 0)"; handle.style.left=v+"%"; knob.style.left=v+"%"; }
  if(range && graded){ range.addEventListener("input",function(){ setBA(this.value); }); setBA(50);
    if(!reduce){ var demoed=false; var ba=document.getElementById("ba");
      var dio=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting&&!demoed){ demoed=true; demoBA(); dio.unobserve(e.target); } }); },{threshold:.5});
      if(ba) dio.observe(ba);
      function demoBA(){ var seq=[[50,75,700],[75,22,900],[22,50,700]], idx=0;
        function run(){ if(idx>=seq.length) return; var from=seq[idx][0],to=seq[idx][1],dur=seq[idx][2],st=null;
          function s(ts){ if(!st)st=ts; var p=Math.min((ts-st)/dur,1); var val=from+(to-from)*(1-Math.pow(1-p,3)); setBA(val); range.value=val; if(p<1) requestAnimationFrame(s); else { idx++; run(); } } requestAnimationFrame(s);
        } run();
      }
    }
  }
})();
